<template>
    <div id="contentbg">
        <div class="tonglan">
            <div class="yysyjs">
                <!--左侧内容-->
                <div class="yysyleft">
                    <h3>医药私域电商解决方案</h3>
                    <h4 id="hfa"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />方案介绍</strong></h4>
                    <ul>
                        <li>
                            <p>汉宁恒丰打造的医药私域电商解决方案，是基于SaaS云服务，采用“软件+产品”的创新模式，为医药企业的线上业务运营赋能，助力企业完成数字化转型。</p>
                            <p>
                                汉宁恒丰医药私域电商解决方案是专门为具有互联网+医药业务规划的商业公司和生产企业，以及已有线上系统但品种资源不足的商业公司而设计。
                            </p>
                            <p>
                                全国智能仓储，精准布局异地设储，代储代运，高效协同，去除中间环节，直击终端，降本增效，降本提速，快速响应需求，极速触达。
                            </p>
                            <p>
                                <img src="@/assets/yyjjfa_02.jpg" width="960" height="412" />
                                <img src="@/assets/yyjjfa_03.jpg" width="960" height="412" />
                            </p>
                        </li>
                    </ul>
                    <h4 id="hrj"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />软件特点</strong></h4>
                    <ul>
                        <li>
                            <p>
                                <strong>医药私域电商解决方案：云端助力、销售升级</strong><br />
                                云端部署：SaaS 服务基于云计算技术，无需企业自行搭建和维护服务器，降低了成本和风险。<br />
                                定制化：根据企业需求提供个性化的解决方案，满足不同企业的业务特点和发展需求。<br />
                                数据安全：采用先进的安全技术，保证企业数据的安全性和隐私性。<br />
                                实时更新：实时更新软件功能，确保企业始终使用最新的技术和功能。<br />
                                成本效益：企业按需付费成本低，避免一次性大额投资，降低运营成本。<br />
                                <img src="@/assets/yyjjfa_04.jpg" width="960" height="337" />
                                <img src="@/assets/yyjjfa_05.jpg" width="960" height="366" />
                            </p>
                        </li>
                    </ul>
                    <h4 id="hgn"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />功能优势</strong></h4>
                    <ul>
                        <li>
                            <img src="@/assets/yyjjfa_06.jpg" width="960" height="231" />
                        </li>
                    </ul>
                    <h4 id="hhz"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />合作价值</strong></h4>
                    <ul>
                        <li>
                            <img src="@/assets/yyjjfa_07.jpg" width="960" height="295" />
                        </li>
                    </ul>
                    <h4 id="hmf"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />免费试用</strong></h4>
                    <ul v-loading="submitLoading">
                        <li>
                            <strong>欢迎您申请免费试用，填写完善信息后，我们将尽快与您取得联系，为您提供服务（<span class="red">*为必填项</span>）。</strong>
                        </li>
                        <div style="width:700px;padding-top:40px;" v-show="!showResult">
                            <el-form ref="regForm" :model="regModel" :rules="rules"  label-width="110px">
                                <el-form-item prop="company" label="企业名称：">
                                    <el-input v-model="regModel.company"></el-input>
                                </el-form-item>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item prop="name" label="您的姓名：">
                                            <el-input v-model="regModel.name"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item prop="mobile" label="手机号：">
                                            <el-input v-model="regModel.mobile"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item prop="require" label="您的需求：">
                                    <el-input v-model="regModel.require" type="textarea"
                                        :rows="3"
                                        placeholder="请输入内容">
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button style="width:100%;border-color: #0868E0;background-color: #0868E0;" type="danger" @click="submitRegInfo">提交</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-result v-show="showResult" :icon="resultSuccess ? 'success' : 'error'" :title="resultSuccess ? '提交成功' : '提交失败'" :subTitle="resultMsg" style="width:700px;">
                            <template slot="extra">
                                <el-button type="primary" size="medium" @click="back">返回</el-button>
                            </template>
                        </el-result>
                    </ul>
                    <h4 id="hzx"><strong><img src="@/assets/yyjjfa_01.jpg" width="8" height="20" />业务咨询</strong></h4>
                    <ul>
                        <li>

                            宋经理：13866202981 &nbsp; 浙江、江西、山西、上海、吉林、广东、广西、青海、贵州、四川、黑龙江<br>

                            张经理：15755835088 &nbsp; 福建、新疆、北京、宁夏、重庆、云南、河南、安徽、辽宁、内蒙古<br>

                            齐经理：15655873330 &nbsp; 山东、海南、西藏、河北、湖北、湖南、江苏、甘肃、天津、陕西<br><br />

                        </li>
                    </ul>
                </div>
                <!--右侧导航-->
                <div class="yysyright">
                    <div class="jjywjsbg" :class="{'yysy-fiexd':isFix}">
                        <h3>医药私域电商解决方案</h3>
                        <ul>
                            <li><a @click="scrollToElement('hfa')" style="cursor: pointer;">方案介绍</a></li>
                            <li><a @click="scrollToElement('hrj')" style="cursor: pointer;">软件特点</a></li>
                            <li><a @click="scrollToElement('hgn')" style="cursor: pointer;">功能优势</a></li>
                            <li><a @click="scrollToElement('hhz')" style="cursor: pointer;">合作价值</a></li>
                            <li class="jjlibg"><a @click="scrollToElement('hmf')" style="cursor: pointer;">免费试用</a></li>
                            <li><a @click="scrollToElement('hzx')" style="cursor: pointer;">业务咨询</a></li>
                        </ul>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { sendValidCode, submitRegInfo } from '../api/register'
import { verifyPhone } from '../utils/toolsValidate'
export default {
  name: 'Saas',
  data () {
    var validPhone = (rule, value, callback) => {
      if (!verifyPhone(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    return {
      regModel: { mobile: '', code: '', name: '', company: '', position: '', type: '3' },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入您的公司名称', trigger: 'blur' }
        ]
      },
      showResult: false,
      resultSuccess: true,
      resultMsg: '',
      submitLoading: false,
      timer: {},
      times: 60,
      codeButtonDisable: true,
      codeButtonText: '获取验证码',
      isFix: false
    }
  },
  mounted: function () {
    if (this.$route.query.target) {
      this.scrollToElement(this.$route.query.target)
    }
    // 添加事件监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    // 移除事件监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (document.documentElement.scrollTop > 135) {
        if (!this.isFix) {
          this.isFix = true
        }
      } else {
        if (this.isFix) {
          this.isFix = false
        }
      }
    },
    checkPhone () {
      if (!this.regModel.mobile) {
        this.$message.error('请输入手机号')
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(this.regModel.mobile)) {
          return true
        } else {
          this.$message.error('手机号码格式不正确')
        }
      }
      return false
    },
    sendValidCode () {
      if (!this.checkPhone()) {
        return
      }
      sendValidCode({ mobile: this.regModel.mobile }).then(response => {
        this.codeButtonDisable = false
        this.timer = setInterval(() => {
          this.times--
          this.codeButtonText = `${this.times}秒后可再次获取`
          if (this.times === 0) {
            this.times = 60
            this.codeButtonDisable = true
            this.codeButtonText = '获取验证码'
            clearInterval(this.timer)
          }
        }, 1000)
      })
    },
    submitRegInfo () {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          submitRegInfo(this.regModel).then(response => {
            this.showResult = true
            this.submitLoading = false
            this.resultSuccess = false
            if (response.data === 'SUCCESS') {
              this.resultSuccess = true
              this.resultMsg = '信息提交成功，请耐心等待客服与您联系。'
            } else if (response.data === 'CODEERROR') {
              this.resultMsg = '验证码错误，请检查输入是否正确，或者重新获取。'
            } else if (response.data === 'REPEAT') {
              this.resultMsg = '您已提交过注册信息，请等待客服人员与您联系。'
            } else {
              this.resultMsg = '注册失败，请稍候再试。'
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    scrollToElement (elementId) {
      const el = document.getElementById(elementId)
      if (el) {
        // 平滑滚动到元素位置
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    back () {
      if (this.resultSuccess) {
        this.$refs.regForm.resetFields()
      }
      this.showResult = false
    }
  }
}
</script>
